/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openinmaps2Inputs */

const en_openinmaps2 = /** @type {(inputs: Openinmaps2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in Maps`)
};

const de_openinmaps2 = /** @type {(inputs: Openinmaps2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Karten öffnen`)
};

/**
* | output |
* | --- |
* | "Open in Maps" |
*
* @param {Openinmaps2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const openinmaps2 = /** @type {((inputs?: Openinmaps2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openinmaps2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openinmaps2(inputs)
	return de_openinmaps2(inputs)
});
export { openinmaps2 as "openInMaps" }